import script from "./ChooseWhatToDoWithVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChooseWhatToDoWithVideo.vue?vue&type=script&setup=true&lang=ts"

import "./ChooseWhatToDoWithVideo.vue?vue&type=style&index=0&id=430e7b21&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-430e7b21"]])

export default __exports__